import { userGroupApi } from "./users-groupsApi";
import { createAsyncThunk } from "@reduxjs/toolkit";
import * as interfaces from "./users-groups.interface";
import { RootState } from "@/app/store";
import { APIError, APIResponse } from "@/types/custom-http";


export const fetchUsersGroups = createAsyncThunk<
  APIResponse<interfaces.UsersGroups[]>,
  void,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'usersGroups/fetchUsersGroups',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        userGroupApi.endpoints.getUsersGroups.initiate()
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
        return rejectWithValue({
          status,
          message: data?.message || 'Error al obtener Grupos de Usuarios',
          details: data.details
        });
    }
  }
);


export const fetchUserGroupById = createAsyncThunk<APIResponse<interfaces.UsersGroups>, number,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'usersGroups/fetchUserGroupById',
  async (id: number, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        userGroupApi.endpoints.getUserGroupById.initiate(id)
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al obtener Grupo de usuario por ID',
        details: data.details
      });
    }
  }
);


export const createUserGroup = createAsyncThunk<APIResponse<interfaces.UsersGroups>, interfaces.CreateUsersGroups,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'usersGroups/createUserGroup',
  async (data: interfaces.CreateUsersGroups, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        userGroupApi.endpoints.createUserGroup.initiate(data)
      ).unwrap();
      
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al crear Grupo de Usuario',
        details: data.details
      });
    }
  }
);



export const updateUserGroup = createAsyncThunk<
  APIResponse<interfaces.UsersGroups>,
   { id: number; changes: interfaces.UpdateUsersGroups }, 
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'usersGroups/updateUserGroup',
  async ({ id, changes  }, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        userGroupApi.endpoints.updateUserGroup.initiate({ id, changes  })
      ).unwrap();

      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al actualizar Grupo de Usuario',
        details: data.details
      });
    }
  }
);


export const deleteUserGroup = createAsyncThunk<
  number,
  number,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'usersGroups/deleteUserGroup',
  async (id: number , { dispatch, rejectWithValue }) => {
    try {
      await dispatch(
        userGroupApi.endpoints.deleteUserGroup.initiate(id)
      ).unwrap();
      
      return id;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al obtener Usuarios',
        details: data.details
      });
    }
  }
);


export const fetchGroupRoleModule = createAsyncThunk<
  APIResponse<interfaces.GroupRoleModule[]>,
  void,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'usersGroups/fetchGroupRoleModule',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        userGroupApi.endpoints.getGroupRoleModule.initiate()
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
        return rejectWithValue({
          status,
          message: data?.message || 'Error al obtener Relaciones Funcionales entre Grupos de Usuarios, Roles y Módulos',
          details: data.details
        });
    }
  }
);


export const fetchGroupRoleModuleByGroupId = createAsyncThunk<APIResponse<interfaces.GroupRoleModule[]>, number,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'usersGroups/fetchGroupRoleModuleByGroupId',
  async (id: number, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        userGroupApi.endpoints.getGroupRoleModuleByGroupid.initiate(id)
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al obtener Relaciones Funcionales entre Grupos de Usuarios, Roles y Módulos',
        details: data.details
      });
    }
  }
);


export const createGroupRoleModule = createAsyncThunk<APIResponse<interfaces.GroupRoleModule>, interfaces.CreateGroupRoleModule,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'usersGroups/createGroupRoleModule',
  async (data: interfaces.CreateGroupRoleModule, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        userGroupApi.endpoints.createGroupRoleModule.initiate(data)
      ).unwrap();
      
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al crear nueva Relación Funcional',
        details: data.details
      });
    }
  }
);


export const deleteGroupRoleModule = createAsyncThunk<
  number,
  number,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'usersGroups/deleteGroupRoleModule',
  async (id , { dispatch, rejectWithValue }) => {
    try {
      await dispatch(
        userGroupApi.endpoints.deleteGroupRoleModule.initiate(id)
      ).unwrap();
      
      return id;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al eliminar Relación Funcional',
        details: data.details
      });
    }
  }
);